import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BookingContainerComponent } from "@app/view/booking/booking-container/booking-container.component";
import { BookingHomeComponent } from "@app/view/booking/booking-home/booking-home.component";
import { VisitBookingComponent } from "@app/view/booking/visit-booking/visit-booking.component";
import { VisitFloatingComponent } from "@app/view/booking/visit-floating/visit-floating.component";
import { JobBookingComponentComponent } from "@app/view/booking/job-booking-component/job-booking-component.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "booking",
    component: BookingContainerComponent,
    data: { title: "scheduler.menu.booking" },
    canActivate: [MsalGuard],
    children: [
      { path: "", redirectTo: "home", pathMatch: "prefix" },
      { path: "home", component: BookingHomeComponent },
      { path: "visit/:id", component: VisitBookingComponent },
      { path: "visit/:id/floating", component: VisitFloatingComponent }
    ]
  },
  {
    path: "booking/launch/job/:externalJobRef",
    canActivate: [MsalGuard],
    component: JobBookingComponentComponent,
    data: { hideMenu: true }
  },
  {
    path: "booking/launch/visit/:id",
    canActivate: [MsalGuard],
    component: VisitBookingComponent,
    data: { hideMenu: true, visitOnlyBooking: true }
  },
  {
    path: "booking/launch/visit/:id/floating",
    canActivate: [MsalGuard],
    component: VisitFloatingComponent,
    data: { hideMenu: true, visitOnlyBooking: true }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingRoutingModule {}
